import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import WrapperFilter from "../WrapperFilter";
import moment from "moment";
import FilterTimeFromTo from "../FilterTimeFromTo";
import FilterTextTag from "../FilterTextTag";

interface IFilterCRVTYT {
  setCondition: Dispatch<SetStateAction<any>>;
}

function FilterCRVTYT({ setCondition }: IFilterCRVTYT) {
  const originFilter: { [key: string]: any } = {
    ten_vtyt: "",
    dvt: "",
    soluong: "",
    xuatxu: "",
    nhanhieu: "",
    kyhieu: "",
    hsx: "",
    mahs: "",
    model: "",
    soluuhanh: "",
    cauhinhkythuat: "",
    tbmt: "",
    cdt: "",
    sqd: "",
    diadiem: "",
    ngayqdFrom: null,
    ngayqdTo: null,
  };
  const [filter, setFilter] = useState<{ [key: string]: any }>(originFilter);
  const [toggleClear, setToggleClear] = useState<number>(0);

  const refreshFilter = () => {
    setFilter(originFilter);
    setToggleClear(toggleClear + 1);
  };

  useEffect(() => {
    const condition: { [key: string]: any } = {};
    if (filter.ten_vtyt) {
      condition.ten_vtyt = { $regex: filter.ten_vtyt, $options: "i" };
    }
    if (filter.dvt) {
      condition.dvt = { $regex: filter.dvt, $options: "i" };
    }
    if (filter.xuatxu) {
      condition.xuatxu = { $regex: filter.xuatxu, $options: "i" };
    }
    if (filter.nhanhieu) {
      condition.nhanhieu = { $regex: filter.nhanhieu, $options: "i" };
    }
    if (filter.kyhieu) {
      condition.kyhieu = { $regex: filter.kyhieu, $options: "i" };
    }
    if (filter.hsx) {
      condition.hsx = { $regex: filter.hsx, $options: "i" };
    }
    if (filter.mahs) {
      condition.mahs = { $regex: filter.mahs, $options: "i" };
    }
    if (filter.model) {
      condition.model = { $regex: filter.model, $options: "i" };
    }
    if (filter.soluuhanh) {
      condition.soluuhanh = { $regex: filter.soluuhanh, $options: "i" };
    }
    if (filter.cauhinhkythuat) {
      condition.cauhinhkythuat = {
        $regex: filter.cauhinhkythuat,
        $options: "i",
      };
    }
    if (filter.tbmt) {
      condition.tbmt = { $regex: filter.tbmt, $options: "i" };
    }
    if (filter.cdt) {
      condition.cdt = { $regex: filter.cdt, $options: "i" };
    }
    if (filter.sqd) {
      condition.sqd = { $regex: filter.sqd, $options: "i" };
    }
    if (filter.diadiem) {
      condition.diadiem = { $regex: filter.diadiem, $options: "i" };
    }
    if (filter.ngayquyetdinhFrom || filter.ngayquyetdinhTo) {
      const startDate = moment(filter.ngayquyetdinhFrom)
        .hours(0)
        .minutes(0)
        .seconds(0);
      const endDate = moment(filter.ngayquyetdinhTo)
        .hours(23)
        .minutes(59)
        .seconds(59);
      if (filter.ngayquyetdinhFrom && filter.ngayquyetdinhTo) {
        condition.ngayquyetdinh = { $gte: startDate, $lte: endDate };
      } else if (filter.ngayquyetdinhFrom) {
        condition.ngayquyetdinh = { $gte: startDate };
      } else if (filter.ngayquyetdinhTo) {
        condition.ngayquyetdinh = { $lte: endDate };
      }
    }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <WrapperFilter refreshFilter={refreshFilter}>
      <FilterTimeFromTo
        label="Ngày quyết định"
        defaultTimeFrom={filter.ngayquyetdinhFrom}
        defaultTimeTo={filter.ngayquyetdinhTo}
        onSearch={(times) =>
          setFilter({
            ...filter,
            ngayquyetdinhFrom: times.timeFrom,
            ngayquyetdinhTo: times.timeTo,
          })
        }
      />
      <FilterTextTag
        label="Tên thiết bị"
        placeholder="Tìm theo tên thiết bị"
        toggleClear={toggleClear}
        onSearch={(tags, merge) =>
          setFilter((prev) => {
            let searchString = "";
            for (let i = 0; i < tags?.length; i++) {
              if (i === 0) {
                searchString += `${tags[i]}`;
              } else {
                searchString += `${merge ? ".*" : "|"}${tags[i]}`;
              }
            }
            return {
              ...prev,
              ten_vtyt: searchString,
            };
          })
        }
      />
      <FilterTextTag
        label="Hãng sản xuất"
        placeholder="Tìm theo hãng sản xuất"
        toggleClear={toggleClear}
        onSearch={(tags, merge) =>
          setFilter((prev) => {
            let searchString = "";
            for (let i = 0; i < tags?.length; i++) {
              if (i === 0) {
                searchString += `${tags[i]}`;
              } else {
                searchString += `${merge ? ".*" : "|"}${tags[i]}`;
              }
            }
            return {
              ...prev,
              hsx: searchString,
            };
          })
        }
      />
      <FilterTextTag
        label="Nhãn hiệu"
        placeholder="Tìm theo nhãn hiệu"
        toggleClear={toggleClear}
        onSearch={(tags, merge) =>
          setFilter((prev) => {
            let searchString = "";
            for (let i = 0; i < tags?.length; i++) {
              if (i === 0) {
                searchString += `${tags[i]}`;
              } else {
                searchString += `${merge ? ".*" : "|"}${tags[i]}`;
              }
            }
            return {
              ...prev,
              nhanhieu: searchString,
            };
          })
        }
      />
      <FilterTextTag
        label="Đơn vị tính"
        placeholder="Tìm theo đơn vị tính"
        toggleClear={toggleClear}
        onSearch={(tags, merge) =>
          setFilter((prev) => {
            let searchString = "";
            for (let i = 0; i < tags?.length; i++) {
              if (i === 0) {
                searchString += `${tags[i]}`;
              } else {
                searchString += `${merge ? ".*" : "|"}${tags[i]}`;
              }
            }
            return {
              ...prev,
              dvt: searchString,
            };
          })
        }
      />
      <FilterTextTag
        label="Xuất xứ"
        placeholder="Tìm theo xuất xứ"
        toggleClear={toggleClear}
        onSearch={(tags, merge) =>
          setFilter((prev) => {
            let searchString = "";
            for (let i = 0; i < tags?.length; i++) {
              if (i === 0) {
                searchString += `${tags[i]}`;
              } else {
                searchString += `${merge ? ".*" : "|"}${tags[i]}`;
              }
            }
            return {
              ...prev,
              xuatxu: searchString,
            };
          })
        }
      />
      <FilterTextTag
        label="Ký hiệu"
        placeholder="Tìm theo ký hiệu"
        toggleClear={toggleClear}
        onSearch={(tags, merge) =>
          setFilter((prev) => {
            let searchString = "";
            for (let i = 0; i < tags?.length; i++) {
              if (i === 0) {
                searchString += `${tags[i]}`;
              } else {
                searchString += `${merge ? ".*" : "|"}${tags[i]}`;
              }
            }
            return {
              ...prev,
              kyhieu: searchString,
            };
          })
        }
      />
      <FilterTextTag
        label="Mã hồ sơ"
        placeholder="Tìm theo mã hồ sơ"
        toggleClear={toggleClear}
        onSearch={(tags, merge) =>
          setFilter((prev) => {
            let searchString = "";
            for (let i = 0; i < tags?.length; i++) {
              if (i === 0) {
                searchString += `${tags[i]}`;
              } else {
                searchString += `${merge ? ".*" : "|"}${tags[i]}`;
              }
            }
            return {
              ...prev,
              mahs: searchString,
            };
          })
        }
      />
      <FilterTextTag
        label="Chủng loại"
        placeholder="Tìm theo chủng loại"
        toggleClear={toggleClear}
        onSearch={(tags, merge) =>
          setFilter((prev) => {
            let searchString = "";
            for (let i = 0; i < tags?.length; i++) {
              if (i === 0) {
                searchString += `${tags[i]}`;
              } else {
                searchString += `${merge ? ".*" : "|"}${tags[i]}`;
              }
            }
            return {
              ...prev,
              model: searchString,
            };
          })
        }
      />
      <FilterTextTag
        label="Số lưu hành"
        placeholder="Tìm theo số lưu hành"
        toggleClear={toggleClear}
        onSearch={(tags, merge) =>
          setFilter((prev) => {
            let searchString = "";
            for (let i = 0; i < tags?.length; i++) {
              if (i === 0) {
                searchString += `${tags[i]}`;
              } else {
                searchString += `${merge ? ".*" : "|"}${tags[i]}`;
              }
            }
            return {
              ...prev,
              model: searchString,
            };
          })
        }
      />
      <FilterTextTag
        label="Cấu hình"
        placeholder="Tìm theo cấu hình"
        toggleClear={toggleClear}
        onSearch={(tags, merge) =>
          setFilter((prev) => {
            let searchString = "";
            for (let i = 0; i < tags?.length; i++) {
              if (i === 0) {
                searchString += `${tags[i]}`;
              } else {
                searchString += `${merge ? ".*" : "|"}${tags[i]}`;
              }
            }
            return {
              ...prev,
              model: searchString,
            };
          })
        }
      />
      <FilterTextTag
        label="Mã TBMT"
        placeholder="Tìm theo mã TBMT"
        toggleClear={toggleClear}
        onSearch={(tags, merge) =>
          setFilter((prev) => {
            let searchString = "";
            for (let i = 0; i < tags?.length; i++) {
              if (i === 0) {
                searchString += `${tags[i]}`;
              } else {
                searchString += `${merge ? ".*" : "|"}${tags[i]}`;
              }
            }
            return {
              ...prev,
              tbmt: searchString,
            };
          })
        }
      />
      <FilterTextTag
        label="Tên CĐT"
        placeholder="Tìm theo tên CĐT"
        toggleClear={toggleClear}
        onSearch={(tags, merge) =>
          setFilter((prev) => {
            let searchString = "";
            for (let i = 0; i < tags?.length; i++) {
              if (i === 0) {
                searchString += `${tags[i]}`;
              } else {
                searchString += `${merge ? ".*" : "|"}${tags[i]}`;
              }
            }
            return {
              ...prev,
              cdt: searchString,
            };
          })
        }
      />
      <FilterTextTag
        label="Số QĐ"
        placeholder="Tìm theo số QĐ"
        toggleClear={toggleClear}
        onSearch={(tags, merge) =>
          setFilter((prev) => {
            let searchString = "";
            for (let i = 0; i < tags?.length; i++) {
              if (i === 0) {
                searchString += `${tags[i]}`;
              } else {
                searchString += `${merge ? ".*" : "|"}${tags[i]}`;
              }
            }
            return {
              ...prev,
              sqd: searchString,
            };
          })
        }
      />
      <FilterTextTag
        label="Địa điểm"
        placeholder="Tìm theo địa điểm"
        toggleClear={toggleClear}
        onSearch={(tags, merge) =>
          setFilter((prev) => {
            let searchString = "";
            for (let i = 0; i < tags?.length; i++) {
              if (i === 0) {
                searchString += `${tags[i]}`;
              } else {
                searchString += `${merge ? ".*" : "|"}${tags[i]}`;
              }
            }
            return {
              ...prev,
              diadiem: searchString,
            };
          })
        }
      />
    </WrapperFilter>
  );
}

export default FilterCRVTYT;
